import { path } from './path';

export const Headers = {
  SessionToken: 'x-session-token',
  Authorization: 'Authorization',
  UserInfo: 'X-USERINFO',
};

export const RETRY_DELAY_MSEC = 1e3;
export const RETRY_ATTEMPS = 4;
export const StatusCode = {
  BAD: 400,
  SUCCESS: 200,
};

export const postBodyEndpoints = new Set([
  path.GET_MESSAGES_API,
  path.GET_CANDIDATE_BY_ID,
  path.TOKEN_INFO,
  path.GET_BASIC_CUSTOMER_INFO,
  path.CANDIDATES,
  path.SEND_MESSAGE,
  path.TRACK_ACTIVE,
  path.TRACK_SESSION,
]);
